import { IComicNameListItem } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

async function getComicNameAutocomplete(
  searchKeyword: string | null
): Promise<AxiosResponse<FetchResult<IComicNameListItem[]>>> {
  const response = await instance.get(`/comics?search=${searchKeyword}`);
  return response;
}

const useFetchComicNameAutocomplete = (searchKeyword: string | null) => {
  const { data: originalData } = useQuery({
    queryKey: ['get', `/comics?search=${searchKeyword}`],
    queryFn: () => getComicNameAutocomplete(searchKeyword),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(searchKeyword && searchKeyword.length > 0)
  });

  const data = originalData?.data.data;

  return { data };
};

export default useFetchComicNameAutocomplete;
